<template>
  <router-link v-if="data" :to="`/${data?.url}`">
    <div class="local-designer bg-white pa-10 bd-1 bd-gray-300-new br-12 ml-4 mr-4">
      <div class="local-designer__content flex items-center mb-20">
        <Avatar :src="data?.avatar" :name="fullName" :alt="fullName" :size="52" />
        <div class="local-designer__context fs-16 fw-500 lh-24 ml-12">
          <div class="name fw-700 lh-18 fs-16 gray-900 mb-4">
            {{ data?.name }}
          </div>
          <div class="reviews gray-900 flex items-center grid-gap-8">
            <div class="rating bg-yellow-score pa-2 px-6 br-1000 flex items-center">
              <span class="fs-12 fw-600 lh-16 black">
                {{ data?.rating }}
              </span>
              <DJIcon class="ml-4" :size="10">
                <IconStarFill />
              </DJIcon>
            </div>
            <div class="number-reviews gray-700 fs-12 fw-400 lh-16" v-if="data?.review_count || data?.number_of_reviews">
              {{
                `(${data?.review_count || data?.number_of_reviews || 0} ${data?.review_count === 1 || data?.number_of_reviews === 1 ? 'review' : 'reviews'}) `
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="search-ld-card__additional-content flex flex-column">
        <div class="expertises items-center truncate truncate-1 black" v-if="data?.expertise">
          <DJIcon class="mr-4">
            <IconPersonCelebrate />
          </DJIcon>
          {{ data?.expertise }}
        </div>
        <div class="expertises items-center truncate truncate-1 black" v-if="data?.languages">
          <DJIcon class="mr-4">
            <IconTranslate />
          </DJIcon>
          {{ data?.languages }}
        </div>
      </div>
    </div>
  </router-link>
</template>

<script setup>
import { computed } from 'vue'
import Avatar from '~/components/ui/avatar/Avatar.vue'
import DJIcon from '~/components/ui/icon/Icon.vue'
import { IconPersonCelebrate, IconStarFill, IconTranslate } from '~/components/ui/icon/icons'
const props = defineProps({
  data: {
    type: Object,
  },
})
const fullName = computed(() => `${props.data.first_name} ${props.data.last_name}`)
</script>

<style lang="scss" scoped></style>
